var path = 'templates/partial/fav-list.html';
var html = "<div style=width:300px;height:350px;display:inline-block class=entry-wrapper ng-repeat=\"fav in favs\" ng-init=\"entry = Books.get(fav.$id)\" ng-include=\"'templates/partial/entry_card.html'\"> </div> <p ng-if=\"!favs || !favs.length\"> 「お気に入り」に追加された資料はありません。<br> 史料をお気に入りに追加するには、翻刻画面で史料タイトル横にある「☆」アイコンを押してください。</p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/partial/fav-list.html
// module id = 38
// module chunks = 0